import React, { useState, useEffect, useContext } from 'react'
import { connect } from 'react-redux'

import { saveDraftProject, getTrainerIndex, fetchTrainerIndex, 
  getTopicIndex, fetchTopicIndex, getLocation, fetchLocation, 
  createProject, updateProject } from '../../../store/client'

import { NavigationContext } from '../../../shared/ui/NavigationController'
import Button from '../../../shared/ui/Button'
import { formatValue } from '../../../shared/ui/TableData'
import InputField, { validateInput } from '../../../shared/ui/InputField'
import Section from '../../../shared/ui/Section'
import Link from '../../../shared/ui/Link'
import DialogBox from '../../../shared/ui/DialogBox'

import VenueForm from './VenueForm'
import ProviderCard from './ProviderCard'
import PreferredTrainersFormView from './PreferredTrainersFormView'

import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'
import Avatar from '@material-ui/core/Avatar'
import ProviderIcon from '@material-ui/icons/School'

import moment from 'moment'

const styles = theme => ({
  root: {
  },
  courseTitle: {
    fontSize: theme.typography.h6.fontSize,
    fontWeight: 600
  },
  detailLabel: {
    fontSize: theme.typography.body2.fontSize,
    color: '#888'
  },
  detailValue: {
  },
  providerCard: {
    //padding: theme.spacing.unit * 2,    
  },
  providerCardAvatar: {
    width: theme.spacing(8),
    height: theme.spacing(8),    
  },
  providerCardName: {
    fontSize: theme.typography.body1.fontSize,
    fontWeight: 600,
  },
})

const ProjectFormView = ({ theme, classes, course, open=true, onSave, onClose, ...props }) => {
  
  const { fetchTrainers, trainer, isEdit=false, initialData, createProject, saveDraftProject, fetchCategories, categories, showDialog, type='custom' } = props
  
  const navigationContext = useContext(NavigationContext)
  const [hasEdit, setHasEdit] = useState(false)

  useEffect(() => {
    fetchCategories()
  }, [])
  
  const deliveryMethodOptions = [
    { text: 'Offline', value: 'offline' },
    { text: 'Online', value: 'online'}
  ]
  const deliveryAppOptions = [
    'Zoom',
    'Google Meet',
    'Cisco WebEx',
    'Microsoft Teams',
    'BlueJeans'
  ]
  
  let priceList = []
  if (course && course.prices)
    priceList = course.prices.sort((a, b) => 
        a.min_participant_count - b.min_participant_count
      )
  
  const minParticipantCount = priceList.length > 0 ? priceList[0].min_participant_count : 10  
      
  const calcTotal = () => {
    const quantity = formData.participant_count
    const price = priceList.reverse().find(p => quantity >= p.min_participant_count)      
    if (price)
      return quantity * price.price_per_participant
    return 0
  }  
  
  const participantCountOptions = Array.from(Array(20), (_, i) => i + minParticipantCount)
  const trainingDaysOptions = Array.from(Array(10), (_, i) => i + 1)

  let emptyDate = {training_date:null}
  let initialForm = {
    course: course ? { uid: course.uid } : null,
    customer_type: 'private',
    delivery_method: 'offline',
    delivery_app: 'Google Meet',
    participant_count: minParticipantCount,
    training_days: course ? course.training_days : 1,
    venue: { in_house: true, state: "DKI Jakarta" },
    schedules: course ? Array.from({length: course.training_days}, (v, i) => emptyDate) : [{training_dates:null}]
  }
  
  const [formData, setFormData] = useState(isEdit ? initialData : initialForm)
  
  let requirements = []
  if (!course && formData.description && formData.description.startsWith('{'))
    requirements = JSON.parse(formData.description)
  
  const [errorFields, setErrorFields] = useState({})
  
  const onChange = (fieldName) => (value) => {
    let newFormData = {
      ...formData,
      [fieldName]: value
    }

    const training_days = newFormData.training_days
    
    if (training_days !== (formData.schedules ? formData.schedules.length : 1)) {
      if (formData.schedules){
        let schedules = [...formData.schedules]
        if (training_days > formData.schedules.length)
          while (schedules.length < training_days)
            schedules.push({training_date:null})
        else
          schedules.splice(training_days, schedules.length - training_days)      
          
        newFormData.schedules = schedules
      }
  }
    
    setFormData(newFormData)
    setHasEdit(true)
  }

  const onVenueDataChange = (fieldName) => (value) => {
    setFormData({
      ...formData,
      venue: {
        ...(formData.venue || {}),
        [fieldName]: value
      }      
    })    
    setHasEdit(true)
  }

  const onCategoryDataChange = (fieldName) => (value) => {
    setFormData({
      ...formData,
      category: {
        ...(formData.category || {}),
        uid: value
      }      
    }) 
    setHasEdit(true)   
  }

  const getDateError = (index, fieldName) => {
    if (errorFields.schedules && index < errorFields.schedules.length)
      return errorFields.schedules[index]
    return null
  }

  const onDateDataChange = (index, fieldName) => (value) => {
    setFormData({
      ...formData,
      schedules: formData.schedules.map((c, i) => {
        if (index === i)
          return {
            training_date: value
          }
        else 
          return c.training_date !== null ? c : {training_date : moment(value).add(i, 'd').format('YYYY-MM-DD')}
      }),
      training_date: index === 0 ? value : formData.training_date
    })  
  }

  const onFormDataChange = (data) => {
    // alert("onFormDataChange: " + JSON.stringify(data, null, 2))
    setFormData({
      ...formData,
      ...data
    })
  }
  
  const onRequirementDataChange = (fieldName) => (value) => {
    setFormData({
      ...formData,
      description: JSON.stringify({
        ...requirements,
        [fieldName]: value
      })
    })
  }
    
  const validateAndSave = (value = 'submit') => {
    let errors = {}    
    
    if (course) {
      // Off the shelf course
    } else {
      // Custom course
      if (!validateInput(formData.category, true))
        errors.category = "Category is required"
      if (!validateInput(formData.title, true))
        errors.title = "Course title is required"
      if (!validateInput(requirements.objectives, true))
        errors.description = "Objectives is required"
      if (!validateInput(requirements.audience, true))
        errors.description = "Audience is required"                       
    }
    
    if (!validateInput(formData.training_date, true))
      errors.training_date = "Training date is required"      
    
    if (formData.delivery_method == 'offline') {
      let venueErrors={}
      
      if (!validateInput(formData.venue.state, true))
        venueErrors.state = "State/province is required"
      if (!validateInput(formData.venue.line4, true))
        venueErrors.line4 = "City is required"
        
      if (Object.keys(venueErrors).length > 0)
        errors.venue = venueErrors 
    } else {
      if (!validateInput(formData.delivery_app, true))
        errors.delivery_app = "Delivery app is required"
    }

    let trainingDatesError=[]
    if(!isEdit){
      formData.schedules.forEach(p => {
        let pErrors = {}
        if (!validateInput(p.training_date, true))
          pErrors = "Date is required"
          
        trainingDatesError.push(pErrors)
      })
    }
    
    if (trainingDatesError.find(p => Object.keys(p).length > 0))
      errors.schedules = trainingDatesError
    
    setErrorFields(errors)
    
    if (Object.keys(errors).length > 0) {
      alert("Please fix all input warnings to continue.")
      return
    }
    
    if (!isEdit && type !== 'custom') {
      if (!formData.agree) {
        alert("You have to agree to Terms and Conditions")
        return
      }
    }

    if (formData.trainers && formData.trainers.length > 0) {
      formData['preferred_trainer'] = formData.trainers[0] ? {uid: formData.trainers[0].uid } : {}
      formData['alt_trainer_1'] = formData.trainers[1] ? {uid: formData.trainers[1].uid } : {}
      formData['alt_trainer_2'] = formData.trainers[2] ? {uid: formData.trainers[2].uid } : {}
    }
    
    navigationContext.showLoadingDialog(true)

    if(isEdit) {
      onSave(formData, () => {
        navigationContext.showLoadingDialog(false)
        navigationContext.showMessageDialog(true)
        navigationContext.setMessageDialog({title:'Congratulations!', description:'Order has been updated!'})
        onClose()
      })
    } else {
      if(value !== 'draft'){
        createProject(formData, (id) => {
          navigationContext.showLoadingDialog(false)
          navigationContext.showMessageDialog(true)
          navigationContext.setMessageDialog(
            {
              title:'Congratulations!', 
              description:'Your order has been created. Please wait for the training provider to respond to your order.'
            }
          )
          navigationContext.openLink('/company/order/view/'+id)      
        }, () => {
          navigationContext.showLoadingDialog(false)
        })
      }else {
        saveDraftProject(formData, (id) => {
          navigationContext.showLoadingDialog(false)
          navigationContext.showMessageDialog(true)
          navigationContext.setMessageDialog(
            {
              title:'Congratulations!', 
              description:'Your order has been created. Click Submit Request to start your order process.'
            }
          )
          navigationContext.openLink('/company/order/view/'+id)      
        }, () => {
          navigationContext.showLoadingDialog(false)
        })
      } 
    }          
  }

  const cancel = () => {
    if (hasEdit) {
      if (window.confirm("Discard form?")){
        onClose()
      }
    } else
        onClose()
    
    setFormData(initialForm)
  }  

  const buttonsAction = []

  if ( !isEdit && type !== 'private')
    buttonsAction.push(
      <Button variant='contained' color='primary' onClick={() => validateAndSave('draft')} fullWidth>
        Continue
      </Button>
    )
  else
    buttonsAction.push(
      <Button variant='contained' color='primary' onClick={() => validateAndSave()} fullWidth>
        {isEdit ? 'Save' : 'Submit Request'}
      </Button>
    )
  
  return (
    <DialogBox 
    title={type !== 'custom' ? ( isEdit ? 'Edit Request' : 'Order Private Course') : ( isEdit ? 'Edit Request' : 'Order Custom Course')} 
    show={showDialog} 
    onClose={cancel} 
    actionButtons={buttonsAction}
    >
      <Box display='flex' flexDirection='column' alignItems='stretched'>
        {/*
        <Section gutterBottom>
          <Typography variant='h4'>
            Order Public Class
          </Typography>
        </Section>
        */}
        
        { course ?
          <Section title="Course" gutterBottom>
            <Section variant='subsection' gutterBottom>
              <Typography component='h6' className={classes.courseTitle}>
                { course.name }
              </Typography>
              <Typography>
                { course.training_days } day{ course.training_days > 1 ? "s" : ""}
              </Typography>
            </Section>
            { !isEdit &&
            <Section title="Training Provider" variant='subsection'>
              <ProviderCard theme={theme} classes={classes}
                item={course.provider}
                linkTo={`/provider/${course.provider.uid}`}
              />
            </Section>
            }
          </Section>
        :
          <Section title="Course Detail" gutterBottom>
            <InputField
              fieldName='category'
              name='category'
              type='option'
              label='Category'
              value={formData.category ? formData.category.uid : null}
              options={categories.lastFetched ? categories.data.records.filter(c => c.key !== 'default').sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0)): []}
              error={errorFields.category}
              onChange={onCategoryDataChange('category')}
              />
            <InputField
              fieldName='title'
              type='text'
              label='Course Name'
              value={formData.title}
              error={errorFields.title}
              onChange={onChange('title')}
              />
            <InputField
              fieldName='training_days'
              type='option'
              options={trainingDaysOptions}
              label='Course Duration (Days)'
              value={formData.training_days}
              error={errorFields.training_days}
              onChange={onChange('training_days')}
              />            
            <InputField
              fieldName='objectives'
              type='textarea'
              label='Training objectives'
              value={requirements.objectives}
              error={errorFields.objectives}
              onChange={onRequirementDataChange('objectives')}
              />
            <InputField
              fieldName='audience'
              type='textarea'
              label='Who is the training for'
              value={requirements.audience}
              error={errorFields.audience}
              onChange={onRequirementDataChange('audience')}
              />
            {/* <InputField
              fieldName='syllabus'
              type='textarea'
              label='Syllabus'
              value={requirements.syllabus}
              error={errorFields.syllabus}
              onChange={onRequirementDataChange('syllabus')}
              />                         */}
          </Section>
        }
          
        <Section title="Order Detail" gutterBottom>
          <Box display='flex'>
            <Box flexGrow={1} mr={1}>
              <Typography className={classes.detailLabel}>
                Delivery Method
              </Typography>
              <Box mt={1}>
                <InputField
                  fieldName='delivery_method'
                  type='option'
                  options={deliveryMethodOptions}
                  value={formData.delivery_method}
                  onChange={onChange('delivery_method')}
                />                            
              </Box>
            </Box>
            { formData.delivery_method === 'offline' ?
              <Box flexGrow={1} mr={1}>
                <Typography className={classes.detailLabel}>
                  Venue
                </Typography>
                <Box mt={1}>
                  <VenueForm
                    formData={formData.venue}
                    onFormDataChange={onVenueDataChange}
                    errorFields={errorFields.venue}
                  />
                </Box>
              </Box>
            :
              <Box flexGrow={1} mr={1}>
                <Typography className={classes.detailLabel}>
                  App
                </Typography>
                <Box mt={1}>
                  <InputField
                    fieldName='delivery_app'
                    type='option'
                    options={deliveryAppOptions}
                    value={formData.delivery_app}
                    onChange={onChange('delivery_app')}
                  />                            
                </Box>
              </Box>
              
            }
            <Box flexGrow={1} width='8em' mr={1}>
              <Typography className={classes.detailLabel}>
                Date
              </Typography>
              <Box mt={1}>
                { formData.schedules && formData.schedules.map((item, index) =>
                <InputField
                  fieldName={`training_date_${index}`}
                  type='date'
                  value={item ? item.training_date : ''}
                  label={'Day '+(index+1)}
                  onChange={onDateDataChange(index,'training_date')}
                  error={getDateError(index, 'training_date')}
                  />   
                )}  
                { !formData.schedules && 
                  <InputField
                  fieldName={`training_date`}
                  type='date'
                  label={"Day 1"}
                  value={formData.training_date}
                  onChange={onChange('training_date')}
                  />   
                }                         
              </Box>
            </Box>
            
            <Box flexGrow={1} mr={1}>
              <Typography className={classes.detailLabel}>
                Pax
              </Typography>
              <Box mt={1}>
                <InputField
                  fieldName='participant_count'
                  type='option'
                  options={participantCountOptions}
                  value={formData.participant_count}
                  onChange={onChange('participant_count')}
                  />                              
              </Box>
            </Box>
            
            { course && 
            <Box flexGrow={1} mr={1}>
              <Typography className={classes.detailLabel}>
                Total
              </Typography>
              <Box mt={1}>
                <Typography className={classes.detailValue}>
                  { formatValue(calcTotal(), 'currency') }              
                </Typography>
              </Box>
            </Box>
            }
          </Box>        
        </Section>

        { course && !isEdit &&
        <Section title="Preferred Trainer">
          <PreferredTrainersFormView
            classes={classes}
            theme={theme}
            edit={true}
            trainers={course.trainers || {}}
            formData={formData}
            onFormDataChange={onFormDataChange}
          />
        </Section>
        }
        
        <Section title="Additional Requests" gutterBottom>
          <InputField
            fieldName='notes'
            type='textarea'
            label=''
            value={formData.notes}
            error={errorFields.notes}
            onChange={onChange('notes')}
            />
        </Section>
        
        { !isEdit && type !== 'custom' &&
        <Section title="Confirmation" gutterBottom>
          <InputField
            fieldName='agree'
            type='checkbox'
            labelStyle={{ zIndex: 3 }}
            label={
              ( <Typography variant='body1'> I agree with PasarTrainer <Link style={{ textDecoration:'underline' }} to={'/page/terms-and-conditions'} target={'_blank'}>Terms and Conditions</Link> </Typography> )
            }
            value={formData.agree}
            onChange={onChange('agree')}
            />                                  
        </Section>  
        }   

      </Box>
    </DialogBox>
  )
}

const mapStateToProps = (state, ownProps) => {
  return {
    trainer: getTrainerIndex(state, 'default', null),   
    categories: getTopicIndex(state, '', null) 
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchTrainers: () => {
      dispatch(fetchTrainerIndex('default', null))
    },
    createProject: (data, onComplete) => {
      dispatch(createProject('new', data, onComplete))
    },
    saveDraftProject: (data, onComplete) => {
      dispatch(saveDraftProject('new', data, onComplete))
    },
    fetchCategories: () => {
      dispatch(fetchTopicIndex('',null, true))
    }
  }
}

export default withStyles(styles, { withTheme: true })(
  connect(
    mapStateToProps,
    mapDispatchToProps
   )(ProjectFormView)
)
